<template>
  <div id="datepicker">
    <v-menu
        ref="start_date_menu_ref"
        v-model="datepicker_menu"
        transition="scale-transition"
        offset-y
        :disabled="disabled"
        tile
        content-class="elevation-0 menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          class="rounded_8px height_56px"
          outlined
          v-model="computed_date"
          :placeholder="placeholder"
          persistent-hint
          readonly
          :rules="rules"
          v-bind="attrs"
          v-on="on"
        >
          <div slot="append" v-bind="attrs" v-on="on">
            <v-icon>
              $icon_calendar
            </v-icon>
          </div>
        </v-text-field>
      </template>
      <v-date-picker
          color="#207EA9"
          flat
          v-model="datepicker_date"
          no-title
          @input="input_date"
      />
    </v-menu>

  </div>
</template>

<script>
import {i18n} from "@/i18n";

export default {
  name: "DatePicker",
  props: [
      'formatted_date', 'placeholder', 'disabled'
  ],
  data: function () {
    return {
      datepicker_menu: false,
      rules: [
        v => !!v || i18n.t('validation.this_field_is_required'),
      ],
      datepicker_date: this.computed_date,
      x: 0,
      y: 0
    }
  },
  methods: {
    show: function (e) {
      e.preventDefault()
      this.datepicker_menu=false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
          this.datepicker_menu = true
        })
    },
    input_date: function () {
      this.datepicker_menu=false
      this.$emit('input_date', {date: this.datepicker_date})
    }
  },
  computed: {
    computed_date: function () {
      let loading_text = i18n.t('general.loading') + '...'
      return this.formatted_date === 'Invalid date' ? loading_text : this.formatted_date
    },
  }
}
</script>

<style lang="scss">
.menu {
  margin-top: 10px;
  contain: initial;
  overflow: visible;
}
.menu::before {
  right: 10px;
  top: -10px;
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #fff transparent;
}
.v-picker--flat {
  border: 1px solid #A7AFB2;
  border-radius: 0;
}
</style>